﻿export default class AddressViewModel {
    public purchaseId: number = 0;
    public streetAddress1: string = '';
    public streetAddress2: string = '';
    public streetAddress3: string = '';
    public city: string = '';
    public province: string = '';
    public postalCode: string = '';
}